import { useMemo } from "react";
import usePlugins from "../usePlugins";
function useEventHandler(editor) {
    const plugins = usePlugins();
    const events = plugins
        .map((p) => p.handlers)
        .flatMap((h) => Object.entries(h).map(([key, value]) => ({
        name: key,
        priority: value.priority,
        handler: value.handler,
    })))
        .sort((e1, e2) => (e2.priority || 0) - (e1.priority || 0));
    return useMemo(() => events.reduce((prev, { name, handler }) => {
        const prevListener = prev[name];
        if (prevListener) {
            prev[name] = (ev) => {
                const handled = prevListener(ev);
                if (!handled) {
                    return handler(ev, editor);
                }
                return handled;
            };
            return prev;
        }
        else {
            return Object.assign(Object.assign({}, prev), { [name]: (ev) => handler(ev, editor) });
        }
    }, {}), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [plugins, editor]);
}
export default useEventHandler;
